import React from "react";
import Barcode from "react-barcode";

const BarcodeGenerator =  ({login, password}) => {
  var valueWithTab = login + "\t" + password;
  return <Barcode value={valueWithTab}  text={" "}/>;
};

export default BarcodeGenerator;
